'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reducers = exports.actions = exports.middlewares = undefined;

var _themeProvider = require('@spp/theme-provider');

var _reduxSpid = require('@spp/redux-spid');

var _coreNavigationUi = require('./redux/core-navigation-ui');

var _CoreNavigation = require('./components/CoreNavigation');

var _CoreNavigation2 = _interopRequireDefault(_CoreNavigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
var middlewares = {
    spid: _reduxSpid.middleware,
    coreNavigationUI: _coreNavigationUi.middleware
};

var actions = {
    spid: _reduxSpid.actions,
    coreNavigationUI: _coreNavigationUi.actions
};

var reducers = {
    spid: _reduxSpid.reducers.spid,
    coreNavigationUI: _coreNavigationUi.reducers
};

exports.default = (0, _themeProvider.themer)('@spp/ui-core-navigation')(_CoreNavigation2.default);
exports.middlewares = middlewares;
exports.actions = actions;
exports.reducers = reducers;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/index.js
 ** module id = 118
 ** module chunks = 1
 **/